import React, { useState } from "react";
import { Button, Drawer, Form, Input } from "@payping/web-components";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Close } from "@payping/icons";
import { ValidPersianName } from "@payping/utils/validation";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { isPersonalDisable } from "@/mobile/Settings/Personal/Edit/isPersonalDisable";
import { DashboardRoutes } from "@/router";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { settingsPersonalAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsPersonalAtom, (val) => val.mobileFormEdit);

const MobileEditPersonalFatherName: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [form] = Form.useForm();
  const { t } = useAppTranslation();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);
  const fatherNameApi = useAppSelector((state) => state.user.personalInfo?.fatherName);

  const [fatherName, setFatherName] = useState<string | undefined>();

  // Custom Hooks
  const { handleNavigationURL } = useHandleNavigationURL();
  const { saveToRedux } = useSaveToRedux();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        title={`${t("edit")} / ${t("profile.fatherName")}`}
        height={"100%"}
        placement={"bottom"}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Form
          onFinish={() =>
            saveToRedux({
              nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditPersonal.phoneNumber.url,
              fieldName: "fatherName",
              fieldValue: fatherName,
              setIsDrawerOpen,
            })
          }
          form={form}
          initialValues={{ fatherName: mobileFormEditState.fatherName ?? fatherNameApi }}
        >
          <Form.Item
            name="fatherName"
            rules={[
              {
                validator(_, value): Promise<void> {
                  if (ValidPersianName(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("profile.validLastName")));
                },
              },
              { required: true },
            ]}
          >
            <Input
              value={fatherName}
              placeholder={t("mobileEditPersonal.enterName")}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFatherName(e.target.value)}
              disabled={isPersonalDisable()}
            />
          </Form.Item>
        </Form>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditPersonalFatherName;
